import { ShowDocumentComponent } from 'src/app/feature-module/documents/component/show-document/show-document.component';
import { UploadDocumentParameters } from 'src/app/feature-module/documents/models/UploadDocumentParameters';
import { DocumentService } from 'src/app/feature-module/documents/service/document.service';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { FileTypeService } from 'src/app/shared/services/file-type.service';
import { Component, ComponentRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogResult, DialogService } from '@progress/kendo-angular-dialog';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { ClaimPhotoDocumentInfo, ClaimPhotoDocumentInfoModel } from '../../models/ClaimPhotoDocumentInfo';
import { DocumentInfo } from '../../models/DocumentInfo';
import { ExportDocumentsService } from '../../service/export-documents.service';
import { UploadFilesSettings } from '../../models/UploadFilesSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { tap } from 'rxjs';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { DialogAlignment } from 'src/app/shared/model/DialogAlignment';
import { ChangePhotosTypeDialogComponent } from '../change-photos-type-dialog/change-photos-type-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: "app-claim-photos",
  templateUrl: "./claim-photos.component.html",
  styleUrls: ["./claim-photos.component.scss"],
})
export class ClaimPhotosComponent implements OnInit {
  constructor(
    private documentService: DocumentService,
    private dialogService: DialogService,
    private fileTypeService: FileTypeService,
    private exportDocumentsService: ExportDocumentsService,
    private customDialogService : CustomDialogService,
    private router: Router
  ) {}

  @Input() documentTypeId: number;
  @Input() isClaimArchived = false;
  @Input() claimId: string;
  @Input() extraReferenceId = '';
  @Input() extraReferenceType = 0;
  @Input() canRemove = true;
  @Input() canUpload = true;
  @Input() canChangeType = false;


  claimPhotos: ClaimPhotoDocumentInfoModel[];
  uploadFilesSettings: UploadFilesSettings;

  isLoading = false;
  isError = false;
  colapsed = false;
  checkedAll: boolean;
  selectedAll: boolean;

  photosIdsToRemove = [];

  @ViewChild("photosDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;


  ngOnInit() {
    const uploadDocumentParameters: UploadDocumentParameters = {
      documentTypeId: this.documentTypeId,
      referenceType: ReferenceType.Claim,
      referenceId: this.claimId,
      extraReferenceId: this.extraReferenceId,
      extraReferenceType: this.extraReferenceType,
      otherDocumentKindName : '',
      description: '',
      proofDocumentIds: []
    };

    const photoRestrictions: FileRestrictions = {
      allowedExtensions: this.fileTypeService.image_extensions,
      maxFileSize: 20971520,
    };

    this.uploadFilesSettings ={
      uploadDocumentParameters: uploadDocumentParameters,
      fileRestrictions: photoRestrictions,
      showTopButtons:false,
      showDocumentDataDialog: false,
      autoUpload : false,
      documentDataDialogContent:null
    };
    this.getClaimPhotos();
  }

  getClaimPhotos() {
    this.isLoading = true;
    this.isError = false;
    this.documentService
      .getClaimPhotos(this.claimId, this.documentTypeId, this.extraReferenceType, this.extraReferenceId)
      .pipe(tap(() =>  this.isLoading = false))
      .subscribe({
        next:(res) => {
        this.claimPhotos = res;
      },
      error: () => {  this.isLoading = false; this.isError = true;}
    });
  }

  getThumb(file: ClaimPhotoDocumentInfo) {
    return "data:image/jpeg;base64," + file.thumb;
  }

  removePhotos(): void {
    this.claimPhotos = this.claimPhotos.filter((x) => !x.isSelected);
  }

  showContent(documentInfo: DocumentInfo) {
    const dialogRef = this.dialogService.open({
      content: ShowDocumentComponent,
      minHeight: "95vh",
      minWidth: "95vw",
      maxHeight: "95vh",
      maxWidth: "95vw",
      appendTo: this.containerRef,
    });

    const dialogObject = (
      dialogRef.content as ComponentRef<ShowDocumentComponent>
    ).instance;
    dialogObject.imageRotated$.subscribe((res) => {
      this.claimPhotos.find((photo) => photo.id == res.id).thumb = res.thumb;
    });
    dialogObject.documentInfo = documentInfo;
    dialogObject.documentInfoCollection = this.claimPhotos;
  }

  toogle() {
    this.colapsed = !this.colapsed;
  }

  toogleAllToExport() {
    this.checkedAll = !this.checkedAll;
    const ids = this.claimPhotos.map((x) => x.id);
    if (this.checkedAll) {
      this.exportDocumentsService.addDocuments(ids);
    } else {
      this.exportDocumentsService.removeDocuments(ids);
    }
  }

  onCheckboxChange(e, documentInfoId: string) {
    this.claimPhotos.find((x) => x.id == documentInfoId).isSelected =
      e.target.checked;
  }

  onButtonDelete(): void {

    if(!this.claimPhotos.filter((photo) => photo.isSelected)?.length){
      return;
    }

    this.customDialogService.actionWithConfirmation('claims-center.claimDocumentation.doYouReallyWantToDeleteSelectedElements',
    () => {
      this.documentService
      .removeBatchClaimPhoto(
        this.claimPhotos
          .filter((photo) => photo.isSelected)
          .map((photo) => photo.id)
      )
      .subscribe(() => this.removePhotos());
        },
        this.containerRef);
  }

  onButtonChangePhotosType(): void {
    const selectedPhotos = this.claimPhotos.filter((photo) => photo.isSelected);
    if(!selectedPhotos?.length){
      return;
    }

    const dialogSettings: CustomDialogSettings = {
      content: ChangePhotosTypeDialogComponent,
      maxHeight: '40vh',
      maxWidth: '40vw',
      appendTo: this.containerRef,
      dialogAlignment: DialogAlignment.center,
      dialogInputs: {
        selectedPhotos: selectedPhotos,
        currentDocumentTypeId: this.documentTypeId
      },
      resultCallback: (r: DialogResult) => {
        if (r['text'] == 'OK') {
          this.router.navigate([this.router.url])
        }
      }
    };

    this.customDialogService.showDialog(dialogSettings);

  }

  onSelectAll(): void {
    this.selectedAll = !this.selectedAll;
    this.claimPhotos.forEach((photo) => (photo.isSelected = this.selectedAll));
  }

  /* UPLOAD INTEGRATION */
  newUploadedItem(ev: any) {
    //change to get only single photo to add
    this.getClaimPhotos();
  }
  /**/
}
